ace.define("ace/snippets/liquid", ["require", "exports", "module"], function (e, t, n) {
  "use strict";

  t.snippetText = undefined, t.scope = "liquid";
});